import { useQuery } from './query';
export function useTravelClass({
  dispatch,
  value,
  initValue,
  getTravelClassesApi,
  getTravelClasses,
  integrationSettings,
  prePopulation,
  meta,
  travelClassFilterv2 = false
}) {
  const getData = () => {
    return getTravelClasses(prePopulation, integrationSettings, meta)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  };
  let optionsApi = null;
  const options = useQuery({ getData, active: getTravelClassesApi }, [
    integrationSettings,
    meta,
    getTravelClasses
  ]);
  if (getTravelClassesApi) {
    optionsApi = { options: options.data };
    if (!options.isLoading && !options.data.some((d) => d.value === value[0])) {
      optionsApi = { ...optionsApi, defaultValue: 'ALL' };
    }
  }

  const onChange = (selectedClass) => {
    dispatch({ type: 'TRAVEL_CLASS_CHANGE', payload: [selectedClass.value] });
  };
  const onChangeV2 = (selectedClass) => {
    dispatch({ type: 'TRAVEL_CLASS_CHANGE_NO_TRACKING', payload: [selectedClass.value] });
  };

  return {
    value,
    defaultValue: value ? value[0] : undefined,
    ...optionsApi,
    onChange: onChange,
    onChangeV2: onChangeV2,
    isChanged: initValue !== value
  };
}
